import React from "react";
import { useMemo, useState, useEffect } from "react";
import Parse from "parse";
import { Box, Image } from "@chakra-ui/react";
import imageUp from "../user.png";

function ShowLogoutAndSettings({ showAvatar }) {
  const [user, setUser] = useState();

  useEffect(() => {
    fetchUser();
  }, []);

  useEffect(() => {
    if (!user) return;
  }, [user]);

  async function fetchUser() {
    const currentUser = Parse.User.current();
    setUser(currentUser);
    return currentUser;
  }

  return (
    <div>
      {user ? (
        <Box
          borderWidth="4px"
          boxShadow="2xl"
          borderRadius="full"
          borderColor="#AEDFFF"
        >
          {showAvatar ? (
            <Image
              src={user.get("avatar") ? user.get("avatar").url() : imageUp}
              borderRadius="full"
              boxSize="80px"
              w={"40px"}
              h={"40px"}
            />
          ) : (
            ""
          )}
        </Box>
      ) : (
        ""
      )}
    </div>
  );
}
export default ShowLogoutAndSettings;
